var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-payments"},[_c('h3',{staticClass:"m-title"},[_vm._v("\n    Payment Methods\n  ")]),_vm._v(" "),_c('PaymentWays',{staticClass:"m-payment"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }